const driveContainer = "_arad16cnxpi";

export { driveContainer };
import "./modal.style.linaria.module.css";
//# sourceMappingURL=modal.style.js.map
